import { TestimonialSlider, type Testimonial } from "../ui/testimonial-slider"

const testimonials: Testimonial[] = [
  {
    image: "/fashion-jewelry-brand-owner-smiling.jpg",
    quote:
      "За первую неделю InstaSell ответил на 400+ DM. Мой conversion rate вырос на 35% просто потому, что клиенты получают ответы мгновенно, а не через 4 часа. Это как иметь идеального assistant который никогда не устает и всегда знает мой inventory.",
    name: "Maria Rodriguez",
    role: "Founder @ Luna Jewelry",
    rating: 5,
  },
  {
    image: "/beauty-brand-owner-at-work.jpg",
    quote:
      "Раньше я тратила весь вечер на ответы в DM, теперь - 30 минут утром на review сложных кейсов. InstaSell освободил мне 3 часа в день, которые я теперь инвестирую в создание контента и работу с поставщиками. Revenue выросла на 40% за 2 месяца.",
    name: "Alex Chen",
    role: "CEO @ Organic Beauty Co.",
    rating: 5,
  },
  {
    image: "/fashion-brand-manager-confident.jpg",
    quote:
      "Самое важное - AI действительно звучит как я. Клиенты не чувствуют, что с ними общается робот. Мы протестировали: 92% не заметили разницы между моими ответами и InstaSell. При этом response time упал с 3 часов до 2 минут.",
    name: "Sophie Laurent",
    role: "Brand Manager @ Maison Style",
    rating: 5,
  },
]

export function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-32 px-4 bg-background overflow-visible">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold mb-4 text-balance">
            Владельцы брендов уже экономят 20+ часов в неделю
          </h2>
          <p className="font-sans text-lg text-muted-foreground max-w-2xl mx-auto">
            Присоединяйтесь к 500+ брендам, которые автоматизировали Instagram сообщения
          </p>
        </div>
        <TestimonialSlider testimonials={testimonials} />
      </div>
    </section>
  )
}
